import React from "react";
import Audio from "../audio";
import { StaticImage } from "gatsby-plugin-image";

const Message = ({ caption }) => (
  <Audio
    src="/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/audio/aliou-cande-in-al-mabani.mp3"
    vtts={["/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/audio/aliou-cande-in-al-mabani.vtt"]}
    image={<StaticImage src="../../../images/mabani/aliou-cande-in-white-robe.jpg" alt="" />}
    caption={caption ? caption : undefined}
  />
);

export default Message;